import styled, { keyframes } from "styled-components"
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles"

const scrollX = keyframes`
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(-50%);
	}
`;

export const HomeBrandsMarqueeWrapper = styled.section`
	overflow: hidden;

	h2 {
		text-align: center;
		color: ${FlexipageColors.blue1000};
		margin: 0 0 2rem;
		text-wrap: balance;

		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.marquee-container {
		position: relative;
		overflow: hidden;
		mask: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
	}

	.marquee {
		width: 100%;
	}

	ul, li {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.marquee-content {
		--_gap: 2.5rem;

		display: flex;
		align-items: center;
		gap: var(--_gap);
		padding-left: var(--_gap);
		width: max-content;

		@media (prefers-reduced-motion: no-preference) {
      animation: ${scrollX} 30s linear infinite;
		}

		&:hover {
			animation-play-state: paused;
		}

		li {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
      height: 25px;
      max-width: 125px;
		}

		img {
			display: block;
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
			white-space: nowrap;
		}
	}
`